import type {TextItem} from '@PosterWhiteboard/items/text-item/text-item.class';
import type {GA4EventSources} from '@Libraries/ga-events';

/**
 * Opens the Text on path drawing mode on the current page — for a new item with placeholder text,
 * or for `item` (its text kept) when a text item's Shapes block asked for a drawn path. `source` is the
 * editor surface it was opened from, for analytics.
 */
export const startTextOnPathDrawing = (source: GA4EventSources, item?: TextItem): void => {
  const whiteboard = window.posterEditor?.whiteboard;
  const page = item?.page ?? whiteboard?.getCurrentPage();
  if (!whiteboard || !page) {
    return;
  }
  void whiteboard.textOnPath.enterDrawMode({page, item, source});
};

export const finishTextOnPathDrawing = (): void => {
  window.posterEditor?.whiteboard?.textOnPath.finishDrawing();
};

/** Ends text on path drawing for another action that takes over (Download, Publish, a click around the page); its paths stay, nothing gets selected. */
export const stopTextOnPathDrawing = (): void => {
  window.posterEditor?.whiteboard?.textOnPath.stopDrawing();
};
